export default function TrainingIcon({ width = "40px", stroke = "#667085" }) {
    return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 20.5V16M7 20.5C7 21.3284 7.67157 22 8.5 22C9.32843 22 10 21.3284 10 20.5V10H14C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8H5C3.34315 8 2 9.34315 2 11V15C2 15.5523 2.44772 16 3 16C3.55228 16 4 15.5523 4 15M7 20.5C7 21.3284 6.32843 22 5.5 22C4.67157 22 4 21.3284 4 20.5V15M4 15V11.5M9 4C9 5.10457 8.10457 6 7 6C5.89543 6 5 5.10457 5 4C5 2.89543 5.89543 2 7 2C8.10457 2 9 2.89543 9 4Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13 16H22V4.5H15.5M12 4.5H15.5M15.5 4.5V3M13 21L16 16L19 21" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


    );
}